import { AddCard, CopyAll } from "@mui/icons-material";
import { TextField, InputAdornment, IconButton, Tooltip } from "@mui/material";
import { v4 as uuidv4 } from "uuid";
import { showSnackbar } from "./UniversalDialog";

export interface TokenFieldProps {
  label?: string;
  value: string;
  onChange: (value: string) => void;
  error?: string;
}

export function TokenField({ value, onChange, error, label }: TokenFieldProps) {
  return <TextField
    label={label || "Access Token"}
    value={value || ""}
    onChange={e => onChange(e.target.value)}
    error={!!error}
    helperText={error}
    multiline
    fullWidth
    slotProps={{
      input: {
        endAdornment: (
          <InputAdornment position="end">
            <div>
              <Tooltip
                title="Generate New Token"
                arrow
                placement="top"
              >
                <IconButton
                  size="small"
                  edge="start"
                  sx={{ padding: 0 }}
                  onClick={() => {
                    const newGUID = uuidv4();
                    onChange(newGUID);
                  }}
                >
                  <AddCard />
                </IconButton>
              </Tooltip>
              <Tooltip
                title="Copy Token"
                arrow
                placement="top"
              >
                <IconButton
                  size="small"
                  edge="start"
                  sx={{ marginLeft: '10px', padding: 0 }}
                  onClick={() => {
                    navigator.clipboard.writeText(value || "");
                    showSnackbar("Token copied to clipboard", "success");
                  }}
                >
                  <CopyAll />
                </IconButton>
              </Tooltip>
            </div>
          </InputAdornment>
        ),
      },
    }}
  />

}